
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.123 4.872c.224.74.906 1.245 1.679 1.245h2.544c.734 0 1.036.942.439 1.369l-2.101 1.502a1.755 1.755 0 00-.656 1.946l.87 2.81c.217.7-.593 1.267-1.178.824l-2.159-1.639a1.755 1.755 0 00-2.122.001L5.29 14.562c-.584.445-1.395-.122-1.178-.824l.868-2.803a1.755 1.755 0 00-.657-1.948l-2.104-1.5c-.597-.427-.296-1.37.439-1.37h2.539c.773 0 1.454-.505 1.68-1.245l.9-2.965c.216-.714 1.227-.714 1.444 0l.9 2.965z","stroke":"#fff"}})])
          )
        }
      }
    